import { inject, Service } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateTime, Settings } from 'luxon';
import { DEFAULT_INTERFACE_LANGUAGE } from '../constants/common/default-interface-language';
import { InterfaceLanguage } from '../enums/interface-language';
import { CommonHelper } from '../helpers/common.helper';

export const INTERFACE_LANGUAGE_KEY = 'interfaceLanguage';

@Service()
export class LanguageService {
  private readonly translateService = inject(TranslateService);

  private readonly language: InterfaceLanguage;

  constructor() {
    const getLanguage = (language: string): InterfaceLanguage | null =>
      CommonHelper.isEnum(InterfaceLanguage, language) ? language : null;

    this.language =
      getLanguage(localStorage.getItem(INTERFACE_LANGUAGE_KEY)!) ??
      getLanguage(navigator.language.slice(0, 2)) ??
      DEFAULT_INTERFACE_LANGUAGE;

    this.setLanguage(this.language);
  }

  public setLanguage(language: InterfaceLanguage): void {
    localStorage.setItem(INTERFACE_LANGUAGE_KEY, language);
    this.translateService.use(this.language);
    this.setLuxonLocale();

    if (language === this.language) return;

    location.reload();
  }

  public getLanguage(): InterfaceLanguage {
    return this.language;
  }

  public getLocale(): string {
    return {
      [InterfaceLanguage.PL]: 'pl-PL',
    }[this.language];
  }

  private setLuxonLocale(): void {
    DateTime.local().setLocale(this.language);
    Settings.defaultLocale = this.language;
  }
}
